import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training',
  templateUrl: './training-life-skill.component.html',
  styleUrls: ['./training-life-skill.component.scss']
})
export class TrainingLifeSkillsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
